export const AREA_TEMPLATE_TYPES = [
    { value: 0, key: 'standard' },
    { value: 1, key: 'singleArea' },
    { value: 2, key: 'custom' },
    { value: 3, key: 'fieldDefined' },
];

export const areaTemplateListQuery = ({ currentPage = null, search = null, area_template_type_id = null }) => {
    let query = `?page=${currentPage}`;
    if (search) query += `&search=${search}`;
    if (area_template_type_id !== null && area_template_type_id !== undefined) {
        query += `&area_template_type_id=${area_template_type_id}`;
    }
    return query;
};
